<template>
  <div class="container">
    <div class="menu-icon" @click="open=true" v-bind:class="{ open: open, pushdown: pushDown }">
      <div class="menu-icon-wrapper">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <div class="menu" v-bind:class="{ open: open }">
      <div class="background" v-bind:class="{ open: open }"></div>
      <a class="close" @click="open=false">&times;</a>
      <nav>
        <router-link :to="{name:'homepage'}" @click.native="open=false">Home</router-link>
        <router-link :to="{name:'offer'}" @click.native="open=false">Shop</router-link>
        <router-link :to="{name:'about'}" @click.native="open=false">About</router-link>
        <a href="http://blog.myxplora.co.uk" target="_blank" @click.native="open=false">Blog</a>
        <a href="http://support.myxplora.co.uk" target="_blank" @click.native="open=false">Support</a>
      </nav>
    </div>
  </div>
</template>

<script>

export default {
  name: 'sideMenu',
  data () {
    return {
      open: false,
      pushDown: false,
    }
  },
  watch: {
    '$route' (to, from) {
      this.checkRoute();
    }
  },
  mounted () {
    this.checkRoute();
  },
  methods: {
    checkRoute() {
      if (this.$route.name == 'homepage')
      {
        this.pushDown = true;
      }
      else
      {
        this.pushDown = false;
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  width: 100%;
  height: 100%;
  z-index: 120;
}
.background {
  width: 100%;
  height: 100%;
  position: fixed;
  background: #fff;
  opacity: 0.0;
  -webkit-transition: 0.4s ease-in-out;
  -moz-transition: 0.4s ease-in-out;
  -o-transition: 0.4s ease-in-out;
  transition: 0.4s ease-in-out;
  z-index: -1;
}
.background.open {
  opacity: 0.9;
}
.menu-icon {
  display: inline-block;
  position: absolute;
  top: 30px;
  left: 20px;
  width: 44px;
  height: 32px;
  cursor: pointer;
  pointer-events: auto;
  opacity: 1;
  z-index: 11;
}
.menu-icon.pushdown {
  /*top: 90px;*/
}
.menu-icon.open {
  pointer-events: none;
  opacity: 0;
}
.menu-icon .menu-icon-wrapper {
  display: inline-block;
  position: relative;
  width: 44px;
  height: 32px;
}
.menu-icon .menu-icon-wrapper span {
  display: inline-block;
  width: 44px;
  height: 4px;
  background: #292a2a;
  position: absolute;
}
.menu-icon .menu-icon-wrapper span:nth-child(2) {
  top: 12px;
}
.menu-icon .menu-icon-wrapper span:nth-child(3) {
  top: 24px;
}
.menu {
  width: 100%;
  height: 100%;
  position: fixed;
  background-color: transparent;
  opacity: 0;
  z-index: 12;
  pointer-events: none;
  -webkit-transition: 0.4s ease-in-out;
  -moz-transition: 0.4s ease-in-out;
  -o-transition: 0.4s ease-in-out;
  transition: 0.4s ease-in-out;
}
.menu.open {
  opacity: 1;
  pointer-events: auto;
}
.menu a.close {
  font-size: 40px;
  line-height: 60px;
  width: 60px;
  height: 60px;
  border-radius: 30px;
  background: #fff;
  position: absolute;
  left: 12px;
  top: 12px;
  cursor: pointer;
  text-align: center;
  z-index: 12;
}
.menu nav {
  display: block;
  padding: 70px 40px;
  z-index: 12;
}
.menu nav a {
  display: block;
  font-size: 32px;
  line-height: 60px;
  cursor: pointer;
  text-align: center;
  opacity: 0.9;
}
/*.menu nav a::before {
  content: "\f105";
  font: normal normal normal 32px/1 FontAwesome;
  margin-right: 20px;
}*/
@media (min-width: 1025px) {
  .menu a.close {
    -webkit-transition: 0.2s ease-in-out;
    -moz-transition: 0.2s ease-in-out;
    -o-transition: 0.2s ease-in-out;
    transition: 0.2s ease-in-out;
  }
  .menu a.close:hover {
    -webkit-transform: rotate(-180deg);
    -moz-transform: rotate(-180deg);
    -ms-transform: rotate(-180deg);
    transform: rotate(-180deg);
  }
  .menu nav a {
    -webkit-transition: 0.2s ease-in-out;
    -moz-transition: 0.2s ease-in-out;
    -o-transition: 0.2s ease-in-out;
    transition: 0.2s ease-in-out;
  }
  .menu nav a:hover {
    opacity: 1;
  }
  .menu-icon .menu-icon-wrapper span {
    -webkit-transition: 0.2s ease-in-out;
    -moz-transition: 0.2s ease-in-out;
    -o-transition: 0.2s ease-in-out;
    transition: 0.2s ease-in-out;
  }
  .menu-icon:hover .menu-icon-wrapper span:nth-child(1) {
    transform: translateY(-4px);
  }
  .menu-icon:hover .menu-icon-wrapper span:nth-child(3) {
    transform: translateY(4px);
  }
}

@media (max-width: 520px) {
  .menu-icon {
    top: 20px;
    left: 20px;
    width: 38px;
  }
  .menu-icon.pushdown {
    /*top: 80px;*/
  }
  .menu-icon .menu-icon-wrapper {
    width: 38px;
  }
  .menu-icon .menu-icon-wrapper span {
    width: 38px;
    height: 3px;
  }
  .menu-icon .menu-icon-wrapper span:nth-child(2) {
    top: 10px;
  }
  .menu-icon .menu-icon-wrapper span:nth-child(3) {
    top: 20px;
  }
  .menu a.close {
    font-size: 32px;
    top: 2px;
    left: 9px;
    background: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SideMenu.vue